import React, { useMemo } from 'react';
import { ResponsiveBar } from '@nivo/bar';
import Typography from '@material-ui/core/Typography';
import { hours } from '../../../data-shapers/weekday-histogram';
import makeData from './make-data';

export default function TrafficDuringWeekChart({ tickets, isLoading }) {
  const data = useMemo(() => makeData(tickets), [tickets]);

  if (isLoading) {
    return (
      <Typography>
        <em>Loading data...</em>
      </Typography>
    );
  } else if (tickets.length === 0) {
    return (
      <Typography>
        <em>No data to display.</em>
      </Typography>
    );
  }

  return (
    <div style={{ height: '300px' }}>
      <ResponsiveBar
        data={data}
        height={300}
        width={820}
        keys={hours}
        colors={{ scheme: 'dark2' }}
        indexBy="day"
        groupMode="stacked"
        labelSkipHeight={20}
        margin={{ top: 50, right: 160, bottom: 50, left: 50 }}
        label="id"
        axisLeft={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
          legend: 'Number of interactions',
          legendPosition: 'middle',
          legendOffset: -40,
        }}
        legends={[
          {
            dataFrom: 'keys',
            anchor: 'top-right',
            direction: 'column',
            justify: false,
            translateX: 110,
            translateY: 0,
            itemWidth: 100,
            itemHeight: 20,
            itemsSpacing: 5,
            symbolSize: 20,
            itemDirection: 'left-to-right',
          },
        ]}
      />
    </div>
  );
}
